import LayoutWithoutNavFooter from '@/components/layouts/LayoutWithoutNavFooter';

export default [
  {
    path: '/vehicle_contract_tracking_navbar',
    title: 'vehicle_contract_tracking_navbar',
    navbar: true,
    icon: 'fa fa-briefcase',
    name: 'vehicle_contract_tracking_navbar',
    component: LayoutWithoutNavFooter,
    meta: { perm: 'Navbar.VehicleContractTracking' },
    children: [
      {
        path: '',
        title: 'vehicle_contract_tracking_navbar',
        icon: 'ion ion-md-settings',
        name: 'vehicle_contract_tracking_navbar',
        component: () => import('@/pages/Management/VehicleManagement/VehicleContractTracking/ContractList'),
      },
    ],
  },
];
